import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    bg: "white",
    _dark: {
      bg: "black.700",
    },
  },
});

export const Card = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {},
});
